import React, { useState, useCallback, memo, useEffect } from 'react';
import { urlSearchParams } from '../../utility/utills';
import Cardactivation from './CardActivationRevamp';
import CardEntry from './CardEntryRevamp';
import Modal from '@components/common/Modal';
import ModalHeader from '@components/common/ModalHeader';
import cn from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    gameCardProcess, gameCardValidate, gameCardBalance
} from '@reducers/payment';
import { setSeat } from '@reducers/orders';
import { setNotification, setErrorPopUp } from '@reducers/notification';
import EventEmitter from '@utility/eventSubscribers';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
// import swipeGameCard from "@assets/JSON_Files/Swipe_Game_Card"
import swipeGameCard from '@assets/images/GIFs/Swipe_Game_Card.gif';
import { TouchableButton } from '@components/common/Touchable'

const GameCard = (props) => {

    // Props Destructuring

    const { auth, deviceInfo, userInfo, seat, gameCardBalance, setErrorPopUp, gameCardValidate, gameCardProcess, setSeat, setNotification,
        serverAppTheme, menuItemsHashTable, orderingPortraitOrientation } = props;

    // State Management

    const [gameCardFlowType, setGameCardFlowType] = useState(urlSearchParams('type') == 'balance' ? 2 : 1);
    const [gameCardData, setGameCardData] = useState(null)
    const [isSwipe, setIsSwipe] = useState(false);
    const [cardError, setCardError] = useState(false)
    const [swiped, setSwiped] = useState([]);
    const [tab, setTab] = useState(false);
    const [sendAndActivatepopUp, setSendAndActivatepopUp] = useState(false);
    const [checkbalance, setCheckbalance] = useState(false)
    const [balancePopUp, setBalancePopUp] = useState({ state: false, data: null });
    const [isLandScape, setIsLandScape] = useState(true)

    // React Hooks
    useEffect(() => {
        if (urlSearchParams('type') === 'balance') {
            setCheckbalance(true);
            setGameCardFlowType(2);
        }
    }, [window.location.search]);

    // Methods

    const entryMethods = auth?.gamingSystemConfig?.entryMethods || [];

    const OnProcess = useCallback((data) => {
        setGameCardData(data);
        if ((entryMethods.length === 1)) {
            if (entryMethods.includes('') || entryMethods.includes('swipe')) {
                openCardPopUp(data)
            } else if (entryMethods.includes('type')) {
                setGameCardFlowType(2)
            }
        } else if (entryMethods.length === 2) {
            setGameCardFlowType(2)
        } else {
            openCardPopUp(data)
        }
    }, [entryMethods]);

    const handleBackBtn = () => {
        setGameCardFlowType(1)
        setGameCardData(null);
        setBalancePopUp({
            state: false,
            data: null,
        });
        setCheckbalance(false)
    }

    const handlegameCardProcess = (data) => {
        const dataToSend = {
            deviceId: deviceInfo.deviceId,
            storeId: userInfo.storeId,
            employeeId: userInfo.id,
            checkHeaderId: checkbalance ? null : seat.id,
            checkOrderItemId: checkbalance ? null : gameCardData?.id,
            entryMethod: 'type',
            cardNumber: data,
        }
        if (checkbalance) {
            gameCardBalance(dataToSend).then((res) => {
                setBalancePopUp({
                    state: true,
                    data: res,
                });

            }).catch((err) => {
                setErrorPopUp({
                    res: err.message
                })
            })
        } else {
            gameCardValidate(dataToSend).then((res) => {
                let value = {
                    checkOrderItemId: gameCardData?.id,
                    entryMethod: 'type',
                    cardNumber: res.cardNumber,
                    cardId: res.cardId,
                    displayCardNumber: res.displayCardNumber,
                    cardTrack: res.cardTrack
                }
                const isPresent = swiped.some(item => item.checkOrderItemId === gameCardData?.id);
                if (!isPresent) {
                    setSwiped(prevArray => [...prevArray, value])
                } else {
                    let index = swiped.findIndex(obj => obj.checkOrderItemId === gameCardData?.id);
                    if (index !== -1) {
                        swiped[index] = value;
                    }
                }
                setGameCardFlowType(1);
            }).catch((err) => {
                setErrorPopUp({
                    res: err.message
                })
            })
        }
    }

    const handleSwipeGameCard = (data) => {
        const dataToSend = {
            deviceId: deviceInfo.deviceId,
            storeId: userInfo.storeId,
            employeeId: userInfo.id,
            checkHeaderId: checkbalance ? null : seat.id,
            checkOrderItemId: checkbalance ? null : (gameCardData?.id || data?.data?.id),
            entryMethod: data.method,
            cardNumber: data?.cardNumber,
        }
        if (checkbalance) {
            gameCardBalance(dataToSend).then((res) => {
                setBalancePopUp({
                    state: true,
                    data: res,
                });
            }).catch((err) => {
                setErrorPopUp({
                    res: err.message
                })
            })
        } else {
            gameCardValidate(dataToSend).then((res) => {
                let value = {
                    checkOrderItemId: (gameCardData?.id || data?.data?.id),
                    entryMethod: data?.method,
                    cardNumber: res.cardNumber,
                    cardId: res.cardId,
                    displayCardNumber: res.displayCardNumber,
                    cardTrack: res.cardTrack
                }
                const isPresent = swiped.some(item => item.checkOrderItemId === data?.data?.id);
                if (!isPresent) {
                    setSwiped(prevArray => [...prevArray, value])
                } else {
                    let index = swiped.findIndex(obj => obj.checkOrderItemId === data?.data?.id);
                    if (index !== -1) {
                        swiped[index] = value;
                    }
                }
                setGameCardFlowType(1);
            }).catch((err) => {
                setErrorPopUp({
                    res: err.message
                })
            })
        }
    }

    const handleStopMagneticRead = () => {
        EventEmitter.stopMagneticCardRead((res) => {
        });
        EventEmitter.sendMessage({ type: 'stopMagCard' }, () => {
            console.log('success');
        },
            () => {
                console.log('failure');
            });
        setIsSwipe(false);
    };

    const activateIngenicoDevice = (data) => {
        try {
            EventEmitter.scanIngenicoDevice((res) => {
                handleSwipeGameCard({ cardNumber: res, method: 'swipe', data: data });
                handleStopMagneticRead();
            },
                () => {
                    handleStopMagneticRead();
                });
            EventEmitter.sendMessage({ type: 'scanMagCard' }, () => {
                console.log('success');
            },
                () => {
                    console.log('failure');
                });
        } catch (e) {
            console.log('catch', e);
        }
    };

    const openCardPopUp = (data) => {
        setIsSwipe(true);
        activateIngenicoDevice(data);
    };

    const sendAndActivateApi = () => {
        const dataToSend = {
            deviceId: deviceInfo.deviceId,
            storeId: userInfo.storeId,
            employeeId: userInfo.id,
            checkHeaderId: seat.id,
            cards: swiped,
        }
        if (swiped.length != 0) {
            gameCardProcess(dataToSend).then((res) => {
                setSeat(res)
                setNotification({
                    type: 'success',
                    message: "Game Card Activated Successfully"
                });
                setSwiped([])
                setTab(true)
            }).catch((err) => {
                setErrorPopUp({
                    res: err.message
                })
            })
        } else {
            setNotification({
                type: 'danger',
                message: 'Please swipe at least one card'
            });
        }
        console.log(dataToSend);

    }

    const sendAndActivate = () => {
        setSendAndActivatepopUp(true)
    }

    const checkBalance = () => {
        setCheckbalance(true)
        setGameCardFlowType(2)
    }

    const handleClosePopup = () => {
        setBalancePopUp({
            state: false,
            data: null,
        });
        setCheckbalance(false)
        setGameCardFlowType(1)
    }

    const handleGamecardFlowType = () => {
        switch (gameCardFlowType) {
            case 1: return <Cardactivation {...props} OnProcess={OnProcess} swiped={swiped} tab={tab} setTab={setTab} sendAndActivate={sendAndActivate} loading={props.loading} checkBalance={checkBalance} serverAppTheme={serverAppTheme} orderingPortraitOrientation={orderingPortraitOrientation} />
            case 2: return <CardEntry {...props} handleBackBtn={handleBackBtn} handlegameCardProcess={handlegameCardProcess} openCardPopUp={openCardPopUp} isSwipe={isSwipe} handleStopMagneticRead={handleStopMagneticRead} cardError={cardError} setCardError={setCardError} loading={props.loading} menuItemsHashTable={menuItemsHashTable} balancePopUp={balancePopUp} handleClosePopup={handleClosePopup} serverAppTheme={serverAppTheme} isLandScape={isLandScape} setErrorPopUp={props.setErrorPopUp} orderingPortraitOrientation={orderingPortraitOrientation} checkbalance={checkbalance}/>
            default: return <div />;
        }
    };

    // HTML CSS Code

    return (
        <>
            <div style={{ fontFamily: 'poppins', background: serverAppTheme?.background_color }} className={cn("col-12 px-0", !isSwipe ? "h-100" : '')}>
                {!isSwipe && handleGamecardFlowType()}
            </div>
            {sendAndActivatepopUp && (
                <Modal
                    isOpen={sendAndActivatepopUp}
                    isModalCenter
                    style={{ backgroundColor: serverAppTheme.popUp_bg, borderRadius: '16px', border: serverAppTheme?.popupBorder, boxShadow: serverAppTheme?.popUp_box_shadow, width: orderingPortraitOrientation ? '486px' : '79%', margin: 'auto', minHeight: orderingPortraitOrientation ? '216px' : '45%', height: 'auto', padding: '1.5rem', position: 'relative', display: 'flex', flexDirection: 'column' }}
                    loading={props.loading}
                    customClass='h-100 w-100'
                    customClass2='h-100 w-100 p-3'
                    noBackground
                >
                    <div className="justify-content-center align-items-center text-center h-100 position-relative" style={{ flex: 1, color: serverAppTheme?.primary_text }}>
                        <div className='col-12 fs_18 fw-700 text-center h-auto'>Are You Sure ?</div><br />
                        <div className="col-12 px-0 fs_15 fw-400 text-center h-auto">
                            {CUSTOM_MESSAGES().SWIPE_MESSAGE}
                        </div>
                        <div style={{ bottom: '0', left: '0' }} className="col-12 px-1 h-30 d-flex mt-auto justify-content-center align-items-center text-center position-absolute">
                            <div className='col-6 pl-0 pr-1'>
                                <TouchableButton type="submit" style={{ backgroundColor: serverAppTheme.OFF_Premise_Btn, border: serverAppTheme.cancleBtn_Border, color: serverAppTheme.cancleBtn_font }} className={cn("col-12 fs_24 fw-600 btn44 rounded")} onClick={(e) => { e.preventDefault(); setSendAndActivatepopUp(false); }}>
                                    {LABEL().NO}
                                </TouchableButton>
                            </div>
                            <div className='col-6 pl-1 pr-0'>
                                <TouchableButton type="submit" style={{ backgroundColor: serverAppTheme?.secondaryBtn, color: serverAppTheme?.btn_font_color }} className={cn("col-12 btn-ripple fs_24 btn44 fw-600 border-0 rounded")} onClick={(e) => { e.preventDefault(); setSendAndActivatepopUp(false); sendAndActivateApi(); }}>
                                    {LABEL().YES}
                                </TouchableButton>
                            </div>
                        </div>
                    </div>
                </Modal>
            )}
            {isSwipe && (
                <div className="col-12  px-0 h-100" style={{ backgroundColor: serverAppTheme?.background_color }}>
                    <div className="col-12 px-0  position-relative h-100" style={{ color: serverAppTheme?.primary_text }}>
                        <ModalHeader
                            tileHeader="Game Card"
                            // isTab={seat?.tab}
                            // stationName={seat?.stationName}
                            // seatNumber={seat?.number}
                        />
                        <div className="col-12 pt-3 px-0 h-100">
                            <div className={cn("col-12 fs_18 fw-700 justify-content-center align-items-center text-center", orderingPortraitOrientation ? 'h-5 pt-3' : 'h-12')}>
                                {CUSTOM_MESSAGES().SWIPE_CARD_AFTER_BEEP}
                            </div>
                            <div className={cn("mx-0 py-2 px-0 row align-items-end col-12 justify-content-center text-center" , orderingPortraitOrientation ? 'h-80' : 'h-60')}>
                                <img src={swipeGameCard} alt="success" style={{ width: orderingPortraitOrientation ? '100%' : '376px', height: '100%' }} />
                            </div>
                            <div className="row px-0 mx-0 justify-content-center position-absolute" style={{ bottom: orderingPortraitOrientation ? '3.5rem' : '3rem', width: '96%', left: '2%' }}>
                                <div className={cn("px-0 d-flex justify-content-center align-items-center", orderingPortraitOrientation ? 'col-7' : 'col-4')}>
                                    <TouchableButton
                                        className={cn("col-12 px-0  fw-600 btn-ripple border-0 rounded d-flex justify-content-center align-items-center", orderingPortraitOrientation ? 'btn68' : 'btn44')}
                                        type="button"
                                        onClick={(e) => { e.preventDefault(); handleStopMagneticRead(); }}
                                        style={{
                                            backgroundColor: serverAppTheme?.secondaryBtn, color: serverAppTheme?.btn_font_color, borderRadius: '8px',
                                        }}
                                        rippleEffect={true}
                                    >
                                        {LABEL().CANCEL}
                                    </TouchableButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

const mapStateToProps = ({ oauth, orders, payment, storeChecks, theme }) => ({
    auth: oauth.authInfo,
    deviceInfo: oauth.deviceInformation,
    paymentCheck: orders.paymentCheck,
    seat: orders.seats,
    userInfo: oauth.loggedInUserData,
    loading: payment.loading || storeChecks.loading || orders.loading,
    menuItemsHashTable: orders.menuItemsHashTable,
    serverAppTheme: theme.serverAppTheme,
    orderingPortraitOrientation: orders.orderingPortraitOrientation
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    gameCardProcess,
    setSeat,
    setNotification,
    gameCardValidate,
    gameCardBalance,
    setErrorPopUp

}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(memo(GameCard));